const dataAccessMethods = require('../../dataAccessMethods');
const mdcConfig = require('@sstdev/lib_metadata-config');
const { applicationNamespaceAdditions } = mdcConfig.config;
const startCase = require('lodash/startCase');
function compareFn(a, b) {
    if (a.prettyName < b.prettyName) {
        return -1;
    }
    return 1;
}
// Avoid mutation of existing namespace/relations
function cloneNamespaces(namespaces) {
    return namespaces.map(ns => {
        return {
            title: ns.title,
            prettyName: ns.prettyName,
            relations: ns.relations
                .map(rel => {
                    return {
                        title: rel.title,
                        prettyName: rel.prettyName
                    };
                })
                .sort(compareFn)
        };
    });
}
function mergeApplicationNamespace(namespaces) {
    // Avoid mutation
    const _namespaces = cloneNamespaces(namespaces);
    let existingApplicationNamespace = _namespaces.find(namespace => namespace.title === 'application');

    if (existingApplicationNamespace == null) {
        existingApplicationNamespace = {
            prettyName: 'Application',
            title: 'application',
            relations: []
        };
        _namespaces.push(existingApplicationNamespace);
    }
    _namespaces.sort(compareFn);
    applicationNamespaceAdditions.relations.forEach(relation => {
        const existing = existingApplicationNamespace.relations.find(r => r.title === relation.title);
        if (existing == null) {
            existingApplicationNamespace.relations.push(relation);
        }
    });
    existingApplicationNamespace.relations.sort(compareFn);

    return _namespaces;
}

// For some reason, defaultValueSelectors passed in were being lost, so memoize them.
let _memoized;
function memoizeDefaultValueSelectors(defaultValueSelectors) {
    if (_memoized == null) {
        _memoized = [
            ['Static Value', 'static'],
            ...defaultValueSelectors.map(selectorName => [startCase(selectorName), selectorName])
        ];
    }
    return _memoized;
}
function configureDataAccess(namespaces = [], defaultValueSelectors = []) {
    const _namespaces = mergeApplicationNamespace(namespaces);
    const _defaultValueSelectors = defaultValueSelectors;
    const getNamespaces = allowBlanks => {
        let results;
        if (_namespaces.length) {
            results = _namespaces.map(ns => [ns.prettyName, ns.title]);
        } else {
            results = [['None Defined', '']];
        }
        if (allowBlanks) {
            results = [['', '']].concat(results);
        }
        return results;
    };
    const getRelations = (workspace, blockId, allowBlanks = false, namespaceProperty = 'namespace') => {
        if (blockId) {
            if (blockId === workspace.creatingBlock) {
                const allRelations = [];
                _namespaces.forEach(ns => {
                    ns.relations.forEach(rel => {
                        allRelations.push([rel.prettyName, rel.title]);
                    });
                });
                return allRelations;
            }
            let block = workspace.getBlockById(blockId);
            let namespace = block.getFieldValue(namespaceProperty);
            if (!namespace) {
                namespace = block.getFieldValue('defaultNamespace');
            }
            const targetNamespace = _namespaces.find(ns => ns.title === namespace);
            if (!namespace || !targetNamespace || !targetNamespace.relations.length) {
                return [['None Available', '']];
            }
            let results = targetNamespace.relations.map(rel => [rel.prettyName, rel.title]);

            if (allowBlanks) {
                results = [['', '']].concat(results);
            }
            return results;
        } else {
            return [['None Defined', '']];
        }
    };

    dataAccessMethods.defineMethod('namespaces', getNamespaces);
    dataAccessMethods.defineMethod('relations', getRelations);
    dataAccessMethods.defineMethod('defaultValueSelectors', () => memoizeDefaultValueSelectors(_defaultValueSelectors));
}

configureDataAccess._private = {
    mergeApplicationNamespace
};
module.exports = configureDataAccess;
